// extracted by mini-css-extract-plugin
export var label = "_ds-5";
export var slideContainer = "_ds-0";
export var slider = "_ds-1";
export var sliderLg = "_ds-4";
export var sliderMd = "_ds-3";
export var sliderSm = "_ds-2";